export default {
    SIZES: ['s', 'm', 'l', 'xl']
};